import { render, staticRenderFns } from "./fileSelect.vue?vue&type=template&id=353ec085&scoped=true&"
import script from "./fileSelect.vue?vue&type=script&lang=js&"
export * from "./fileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ec085",
  null
  
)

export default component.exports